import axios from "axios";
import { baseURL, requestURLs } from "@/Environment";
import i18n from "@/i18n/config";
// import { toast } from "react-toastify";
const ApiRequest = axios.create({
  baseURL,
});
let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
}> = [];

const processQueue = (error: any = null) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve();
    }
  });
  failedQueue = [];
};

ApiRequest.interceptors.request.use((config) => {
  config.headers["organisation-id"] = localStorage.getItem("organisation-id");
  config.headers["Accept-Language"] = i18n.language || "en";

  if (window.location.pathname.includes("collaborator")) {
    config.headers["user-id"] = window.location.pathname.split("/")[2];
  }
  config.withCredentials = true;
  return config;
});

ApiRequest.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const { pathname } = window.location;
    const isOnLoginPage = pathname === "/login";
    const isOnSignupPage = pathname === "/signup";
    const isOnForgotPasswordPage = pathname === "/forgot-password";
    const isOnResetPasswordPage = pathname.includes("/reset-password");
    const isCollaboratorPage = pathname.includes("collaborator");
    if (isOnLoginPage || isOnSignupPage || isOnForgotPasswordPage || isOnResetPasswordPage || isCollaboratorPage) {
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (originalRequest.url?.includes("/auth/access-token")) {
        // toast.error("Session expired, please login again");
        return Promise.reject(error);
      }
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            return ApiRequest(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await ApiRequest.get(requestURLs.refreshToken);
        isRefreshing = false;
        processQueue();
        return ApiRequest(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        processQueue(refreshError);
        // toast.error("Session expired, please login again");
        // window.location.pathname = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default ApiRequest;
